import React from 'react'
import { Link } from 'react-router-dom'

function Passionlux() {
  return (
    <div className='font-thin'>
          <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">

{/* ✅ Breadcrumb Navigation */}
<div className="flex justify-start text-sm md:text-base">
       <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
       <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
       <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
       <span className="block py-1 pl-4 mt-6">PASSION LUX</span>

     </div>
     {/* ✅ Product Image on Top */}
     <div className="flex justify-center mb-6">
       <img src="/images/newpassionlux.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
     </div>

     {/* ✅ Product Title & Description */}
     <div className="text-center mb-6">
       <h1 className="text-3xl md:text-4xl uppercase mb-8">PASSION LUX</h1>
       <p className="text-xl md:text-2xl font-thin max-w-sm mx-auto text-gray-500">Wide area of exposure and sophistication in a single exhibitor.</p>
       <p className="text-xl md:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">Designed to meet the most sophisticated demands of the traditional Pastry, Bakery or Gastronomy service, PASSION LUX is a line with a rigorous design, which offers an excellent view of your products. Find out what this line can do for your business, with specialist models for Pastry, Bakery, Chocolates, Ice-Cream and Take-away, in cooled, dry/ambient and heated versions.</p>
     </div>

     {/* ✅ Models & Model Values */}
<h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>

<div className="grid grid-cols-1 gap-4 text-center mb-6">
   <p className="text-xl md:text-2xl opacity-90">PASTRY <span className='text-blue-500'> +2°… +4°C</span><span className='text-gray-500'>+(3M2)</span> </p>
   <p className="text-xl md:text-2xl opacity-90">BAKERY<span className='text-gray-500'> dry ambient</span> </p>
</div>


     {/* ✅ Refrigeration */}
     <div>
       <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
       <p className="text-xl md:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol |  R290</p>
     </div>



     {/* ✅ Case Images & Features */}
     <div className="flex flex-col gap-8 mt-12">
        {/* case 1 */}
         <div 
           className="flex flex-col  pb-16 mt-10 md:flex-row-reverse gap-6" >
             {/* ✅ Image Wrapper */}
             <div className="w-full md:w-1/2">
             <img src="/images/passcase.jpg" className="max-w-full h-auto object-contain" />
           </div>
           {/* ✅ Case Points */}
           <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Best highlighting and conservation of your cakes and bread.</p>
    <ul className="list-[square] list-outside text-gray-500">
    <li className="text-xl  font-thin opacity-90 mt-6">Fan assisted cooling system which assures an even temperature distribution.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">High exhibition capacity, thanks to the 3 exhibition levels.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Model with cooled shelves.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Cooled storage for a quick restock.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Model with exhibition with roll-out tray to ease the service.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Bread exhibitor with crumb collector.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
</ul>

</div>
            
         </div>

     {/* ✅ Models & Model Values */}
     <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>

<div className="grid grid-cols-1 gap-4 text-center mb-6">
   <p className="text-xl md:text-2xl opacity-90">CHOCOLATES <span className='text-blue-500'> +13°… +15°C</span><span className='text-gray-500'>+(3S)</span> </p>
</div>
        {/* case 2 */}
         <div 
           className="flex flex-col  pb-16 mt-10 md:flex-row-reverse gap-6" >
           {/* ✅ Case Points */}
             {/* ✅ Image Wrapper */}
             <div className="w-full md:w-1/2">
             <img src="/images/passcase1.jpg" className="max-w-full h-auto object-contain" />
           </div>

           <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Chocolates at its best!</p>
    <ul className="list-[square] list-outside text-gray-500">
    <li className="text-xl  font-thin opacity-90 mt-6">Fan assisted cooling system with humidity control.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Stepped deck display tray to highlight your products.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
</ul>

</div>
         </div>
  {/* ✅ Models & Model Values */}
  <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>

<div className="grid grid-cols-1 gap-4 text-center mb-6">
   <p className="text-xl md:text-2xl opacity-90">ICE-CREAM <span className='text-gray-500'> -22°… -20°C (3L1)</span> </p>
</div>
{/* case 3 */}
<div 
           className="flex flex-col  pb-16 mt-10 md:flex-row-reverse gap-6" >
            {/* ✅ Image Wrapper */}
            <div className="w-full md:w-1/2">
             <img src="/images/passcase2.jpg" className="max-w-full h-auto object-contain" />
           </div>
           {/* ✅ Case Points */}
           <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Fresh and tasty ice-creams, hard to resist!</p>
    <ul className="list-[square] list-outside text-gray-500">
    <li className="text-xl  font-thin opacity-90 mt-6">Specialist version for the exhibition and service of ice cream, for 10, 16, or 22 5L pans.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Soft fan-assisted cooling system which assures an even temperature distribution.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Automatic defrost through hot gas for better performance.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Utensil washer for easy service and sanitizing.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
</ul>

</div>
             
         </div>

  {/* ✅ Models & Model Values */}
  <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>

<div className="grid grid-cols-1 gap-4 text-center mb-6">
   <p className="text-xl md:text-2xl opacity-90">COLD MEALS AND SALADS <span className='text-blue-400'>+2°… +5°C</span><span className='text-gray-500'> (3M2)</span> </p>
   <p className="text-xl md:text-2xl opacity-90">HOT MEALS <span className='text-gray-500'>(w/ ventilation)</span><span className='text-red-500'>+60°… +65°C</span> </p>
   <p className="text-xl md:text-2xl opacity-90">HOT MEALS <span className='text-gray-500'>(w/ heating plate)</span><span className='text-red-500'>+60°… +65°C</span> </p>
   <p className="text-xl md:text-2xl opacity-90">HOT MEALS <span className='text-gray-500'> (bain-marie)</span><span className='text-red-500'>+60°… +65°C</span> </p>

</div>
        {/* case 4 */}
        <div 
           className="flex flex-col  pb-16 mt-10 md:flex-row-reverse gap-6" >
           {/* ✅ Case Points */}
          
    {/* ✅ Image Wrapper */}
    <div className="w-full md:w-1/2">
    <img src="/images/passcase3.jpg" className="max-w-full h-auto object-contain" />
  </div>

  <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Always tempting take-away, warm or cool!</p>
    <ul className="list-[square] list-outside text-gray-500">
    <li className="text-xl  font-thin opacity-90 mt-6">Cooled model for salads, predisposed for GN pans.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">4 heated versions: with heated cover, fan-assisted heating, fan-assisted heating with humidification, and bain-marie, which adjust to different foods.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">Quick restock operations, thanks to the heated or cooled stock storage.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">The fan-assisted heating system assures a uniform distribution of temperature and reduces energy consumption.</li>
    <li className="text-xl  font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
</ul>

</div>
         </div>

      
     </div>

 </div>

    </div>
  )
}

export default Passionlux